module.exports = __webpack_public_path__ + "img/line_05.229896ec.jpg";